import { render, staticRenderFns } from "./AvatarField.vue?vue&type=template&id=587ec3ed&"
import script from "./AvatarField.vue?vue&type=script&lang=js&"
export * from "./AvatarField.vue?vue&type=script&lang=js&"
import style0 from "./AvatarField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
